module.exports = __webpack_public_path__ + "img/how it work.9b1838e1.svg";